import { createApp } from 'vue';
import Notifications from '@kyvg/vue3-notification';
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { createRouter, createWebHashHistory } from 'vue-router';
import App from './App.vue';
import Dashboard from './admin/components/Dashboard.vue';
import CourierForm from './admin/modules/couriers/CourierForm.vue';
import ReservationTable from './admin/modules/reservation_table/ReservationTable.vue';
import Settings from './admin/modules/settings/Settings.vue';
import GeneralSettings from './admin/modules/settings/GeneralSettings.vue';
import TemplateSettings from './admin/modules/settings/TemplateSettings/TemplateSettingsIndex.vue';
import ReservationSettings from './admin/modules/settings/ReservationSettings/Reservation_settings.vue';

import Menu from './admin/modules/menu_page/AllMenu.vue';
import Category from './admin/modules/categories/AllCategory.vue';
import Coupon from './admin/modules/coupons/AllCoupon.vue';
import Tables from './admin/modules/tables/AllTables.vue';



import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Create router
const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        { path: '/', component: Dashboard },
        { path: '/category', component: Category },
        { path: '/menus', component: Menu },
        { path: '/coupons', component: Coupon },
        { path: '/tables', component: Tables },
        { path: '/couriers/create', component: CourierForm },
        { path: '/couriers/:id/edit', component: CourierForm, props: true },
        { path: '/reservation_table', component: ReservationTable },

        {
            path: '/settings', component: Settings, children: [
                {
                    path: '',
                    name: 'general-settings',
                    meta: { title: 'General Settings', key: 'general-settings'},
                    component: GeneralSettings
                },
                {
                    path: 'template-settings',
                    name: 'template-settings',
                    meta: { title: 'Template Settings', key: 'general-settings'},
                    component: TemplateSettings
                },
                {
                    path: 'reservation-settings',
                    name: 'reservation-settings',
                    meta: { title: 'Reservation Settings', key: 'reservation-settings'},
                    component: ReservationSettings
                },
            ]
        },
    ]
});

// Create Vuex store
// const store = createStore({
//     state() {
//         return {
//             couriers: [],
//             shipments: []
//         }
//     },
//     mutations: {
//         setCouriers(state, couriers) {
//             state.couriers = couriers;
//         },
//         addCourier(state, courier) {
//             state.couriers.push(courier);
//         },
//         updateCourier(state, courier) {
//             const index = state.couriers.findIndex(c => c.id === courier.id);
//             if (index !== -1) {
//                 state.couriers.splice(index, 1, courier);
//             }
//         },
//         deleteCourier(state, id) {
//             state.couriers = state.couriers.filter(c => c.id !== id);
//         }
//     },
//     actions: {
//         async fetchCouriers({ commit }) {
//             try {
//                 const response = await fetch(
//                     `${RestaurantMenuMangeData.rest_api}/couriers`,
//                     {
//                         headers: {
//                             'X-WP-Nonce': RestaurantMenuMangeData.nonce
//                         }
//                     }
//                 );
//                 const data = await response.json();
//                 if (data.success) {
//                     commit('setCouriers', data.data);
//                 }
//             } catch (error) {
//                 console.error('Error fetching couriers:', error);
//             }
//         },
//         async createCourier({ commit }, courier) {
//             try {
//                 const response = await fetch(
//                     `${RestaurantMenuMangeData.apiUrl}/couriers`,
//                     {
//                         method: 'POST',
//                         headers: {
//                             'Content-Type': 'application/json',
//                             'X-WP-Nonce': RestaurantMenuMangeData.nonce
//                         },
//                         body: JSON.stringify(courier)
//                     }
//                 );
//                 const data = await response.json();
//                 if (data.success) {
//                     commit('addCourier', data.data);
//                     return data.data;
//                 }
//             } catch (error) {
//                 console.error('Error creating courier:', error);
//                 throw error;
//             }
//         }
//     }
// });

// Create and mount Vue app
const app = createApp(App);
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.use(ElementPlus);
app.use(router);
app.use(Notifications);
app.mount('#restaurant-menu-mange-and-order-app');
